/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import { Link } from "gatsby"
import "./layout.css"
const Blog = ({ children }) => {
    const data = (graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
  <ul class="nav fixed-top bg-white">
  <li class="nav-item">
    <Link class="nav-link" to="/">Home</Link>
  </li>
  <li class="nav-item">
  <Link class="nav-link" to="/aplikasi">App</Link>
  </li>
  <li class="nav-item">
  <Link class="nav-link" to="/hardware">Hardware</Link>
  </li>
  <li class="nav-item">
  <Link class="nav-link" to="/contact">Contact</Link>
  </li>
</ul>
	
        <main>{children}</main><hr/>
        <footer class="text-center">
          <br/>
          <small><small>
		<a href="https://www.facebook.com/mesinkasircomplete" class="text-secondary" target="blank">Facebook</a> . <a href="https://www.youtube.com/channel/UCIBWTgOXH5oa2YlbfpO7QLQ/featured" class="text-secondary" target="blank">Youtube</a> . <a href="https://mesinkasir.github.io" class="text-secondary" target="blank">Github</a> . <a href="https://mesinkasironline.web.app/" class="text-secondary" target="blank">web app</a><br/>
          © {new Date().getFullYear()}, 
          {` `}
            <a href="https://mesinkasir.asia" title="mesin kasir online">www.mesinkasir.asia</a> , built with <a href="https://www.gatsbyjs.org/" target="blank">gatsby</a> develope by <a href="https://gatsbyart.web.app" target="blank">Gatsby ART</a>
            <br/>
        <a href="/en/sourcecode" class="text-secondary">source code</a> . <a href="/start" class="text-secondary">get start</a> . <a href="/language" target="_blank" class="text-secondary">Language</a>
            </small></small></footer>
      
      </>
  )
}

Blog.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Blog
